module.exports = __webpack_public_path__ + "img/toplogo.281a1fb9.png";